import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "../General/NotificationStyle.css";
import RecipientModal from "../General/RecipientModal";
import { useDispatch } from "react-redux";
import actions from "../../../store/notificatiommodule/action";
import Services from "../General/NotificationService";
import { toast } from "react-toastify";
import $ from "jquery";
import TriggerTable from "./TriggerTable";
import PermissionFeature from "../../Permissions/PermissionFeature";
import AuthService from "../../Auth/AuthService";

// 🔹 Level 1: Module Table
const ModuleTable = ({
  data,
  expanded,
  onNotificationExpand,
  onTriggerExpand,
}) => {
  const dispatch = useDispatch();

  const handleModuleStatusChange = async (row, checked) => {
    $(".loading").show();
    try {
      const response = await Services.updateModuleStatus(row.id, checked);

      if (response) {
        // reload notifications
        dispatch(actions.fetchNotifications(true));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to update module status.");
    }
    $(".loading").hide();
  };
  const columns = [
    {
      dataField: "name",
      headerClasses:
        "text-nowrap bg-secondary d-none text-white px-sm-3 px-2 py-2",

      classes: "p-0",
      text: "Notification",
      style: {
        width: "90%",
      },
      formatter: (cell, row) => {
        let hasTriggers = row.triggers && row.triggers.length > 0;
        return (
          <div
            className={
              "w-100 px-2 mb-1 rounded-left control-container bg-secondary text-white" +
              (hasTriggers ? " c-pointer" : "")
            }
          >
            {cell} {hasTriggers && <i>({row.triggers.length})</i>}
          </div>
        );
      },
    },
    {
      dataField: "is_Active",
      headerClasses:
        "text-nowrap bg-secondary d-none text-white px-sm-3 px-2 py-2",
      classes: "p-0",
      style: {
        width: "10%",
      },
      text: "Active",
      hidden: !AuthService.canUpdate(PermissionFeature.NotificationDetails),
      formatter: (cell, row) => {
        let hasTriggers = row.triggers && row.triggers.length > 0;

        return (
          <div
            onClick={(e) => e.stopPropagation()}
            className={
              "w-100 rounded-right  mb-1 px-2 control-container bg-secondary text-white" +
              (hasTriggers ? " c-pointer" : "")
            }
          >
            <input
              type="checkbox"
              switch="bool"
              onClick={(e) => {
                e.stopPropagation();
              }}
              checked={cell}
              onChange={(e) => {
                e.preventDefault();
                e.nativeEvent.stopPropagation();
                handleModuleStatusChange(row, e.target.checked);
              }}
              name={"notification-module-" + row.id}
              id={"notification-module-" + row.id}
            />
            <label
              className="mb-n2"
              style={{ height: "23px" }}
              htmlFor={"notification-module-" + row.id}
              data-on-label="On"
              data-off-label="Off"
            />
          </div>
        );
      },
    },
  ];

  const expandRow = {
    renderer: (row) => (
      <TriggerTable
        expanded={expanded.triggers}
        onExpand={onTriggerExpand}
        triggers={row.triggers || []}
      />
    ),
    showExpandColumn: false,
    expanded: expanded.notifications.filter((id) => typeof id === "number"),
    onExpand: onNotificationExpand,
    expandByColumnOnly: false,

    classes: "text-nowrap bg-dark text-white py-2",
    nonExpandable: data
      .filter((row) => !row.triggers || row.triggers.length === 0)
      .map((row) => row.id),
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      return null;
    },

    expandColumnRenderer: ({ expanded, expandable }) => {
      return (
        <div className="w-100 rounded-left px-1 mb-1 control-container c-pointer bg-secondary text-white">
          {expandable ? (expanded ? "(-)" : "(+)") : " "}
        </div>
      );
    },
  };

  return (
    <BootstrapTable
      keyField="id"
      data={data}
      columns={columns}
      expandRow={expandRow}
      classes="expandable notification-module-table"
      bordered={false}
      bootstrap4
    />
  );
};

export default ModuleTable;
